import { useSelector } from 'react-redux';

import SingleDaySection from './DayAvailability/SingleDaySection';
import OverrideSection from './Overrides/OverrideSection';
import RecurringSection from './RecurringAvailability/RecurringSection';

export default function AvailabilityDrawerContent() {
  const { drawer, selectedGroomer } = useSelector((state) => state.ui);
  const { uuid: drawerUuid } = drawer;

  if (selectedGroomer.uuid === 'all') {
    return;
  }

  if (drawerUuid === 'all') {
    return (
      <>
        <RecurringSection />
        <OverrideSection />
      </>
    );
  }

  return <SingleDaySection />;
}
